export default function TechSkills() {
    return (
        <div className="tech-skills-container">
            <h2>Technical Skills</h2>
            <div className='tech-skills'>
            <ul>
                <li>Programming Languages</li>
                <ul>
                    <li>JavaScript</li>
                    <li>CSS</li>
                    <li>Python</li>
                    <li>SQL</li>
                    <li>TypeScript</li>
                </ul>
                <li>Frameworks & Tools</li>
                <ul>
                    <li>Angular</li>
                    <li>Cypress</li>
                    <li>ReactJS</li>
                    <li>Jira</li>
                    <li>Confluence</li>
                    <li>LooperPro</li>
                    <li>PowerBI</li>
                    <li>Figma</li>
                    <li>Azure</li>
                </ul>
                <li>Version Control</li>
                <ul>
                    <li>Git</li>
                    <li>GitHub</li>
                </ul>
            </ul>
            </div>
        </div>
    )
}